import { NavLink } from "react-router-dom";
import { useSession } from "../../hooks/useSession";

const items: { to: string; label: string; admin?: boolean }[] = [
  { to: "/", label: "Overview" },
  { to: "/people", label: "People" },
  { to: "/features", label: "Features" },
  { to: "/insights", label: "Insights" },
  { to: "/conversations", label: "Conversations" },
  { to: "/reports", label: "Reports" },
  { to: "/admin/users", label: "Admin · Users", admin: true },
  { to: "/admin/imports", label: "Admin · Imports", admin: true },
];

export default function Sidebar() {
  const { data: me } = useSession();
  return (
    <aside className="w-56 shrink-0 border-r border-slate-200 bg-white p-4">
      <div className="mb-6 text-sm font-semibold text-slate-900">Claude Monitor</div>
      <nav className="space-y-1">
        {items
          .filter((i) => !i.admin || me?.role === "ADMIN")
          .map((i) => (
            <NavLink
              key={i.to}
              to={i.to}
              end
              className={({ isActive }) =>
                `block rounded px-3 py-2 text-sm ${
                  isActive
                    ? "bg-brand-50 text-brand-700 font-medium"
                    : "text-slate-700 hover:bg-slate-100"
                }`
              }
            >
              {i.label}
            </NavLink>
          ))}
      </nav>
    </aside>
  );
}
